export const DEAL_LIST_REQUEST = 'DEAL_LIST_REQUEST'
export const DEAL_LIST_SUCCESS = 'DEAL_LIST_SUCCESS'
export const DEAL_LIST_FAIL = 'DEAL_LIST_FAIL'
export const DEAL_LIST_RESET = 'DEAL_LIST_RESET'